<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00061.installation.paraminstallation.title' | translate"
      [description]="
        'P00061.installation.paraminstallation.description' | translate
      "
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="
        'P00061.installation.paraminstallation.comportementFiltration.title'
          | translate
      "
      [nameCustom]="
        'P00061.installation.paraminstallation.comportementFiltration.value'
          | translate
      "
      [value]="actionStack!.getValue('ppIActivationFonctionPriorite') !== 0"
      [description]="
        'P00061.installation.paraminstallation.comportementFiltration.description'
          | translate
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACPOLY_Installation,
          'ppIActivationFonctionPriorite',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    <app-switch-configuration
      [title]="
        'P00061.installation.paraminstallation.autoMaintienFiltration.title'
          | translate
      "
      [nameCustom]="
        'P00061.installation.paraminstallation.autoMaintienFiltration.value'
          | translate
      "
      [value]="actionStack!.getValue('ppIActivationFonctionAutoMaintien') !== 0"
      [description]="
        'P00061.installation.paraminstallation.autoMaintienFiltration.description'
          | translate
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACWP_Installation,
          'ppIActivationFonctionAutoMaintien',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
